import { IReceiptStatus } from '@/enums/receipt';

const getReceiptStatusColor = (status: IReceiptStatus): string => {
  switch (status) {
    case IReceiptStatus.PENDING:
      return '#fadb14';
    case IReceiptStatus.PC:
      return '#faad14';
    case IReceiptStatus.OK:
      return '#52c41a';
    default:
      return '#fadb14';
  }
};

const getReceiptStatus = (status: IReceiptStatus): string => {
  switch (status) {
    case IReceiptStatus.OK:
      return 'ส่งสำเร็จ';
    case IReceiptStatus.PC:
      return 'รอตรวจสอบ';
    default:
      return 'ยังไม่ได้ส่ง';
  }
};

const getReceiptStatusOptions = () => {
  return [
    { label: 'ทั้งหมด', value: '' },
    { label: 'ยังไม่ได้ส่ง', value: 'PENDING' },
    { label: 'รอการตรวจสอบ', value: IReceiptStatus.PC },
    { label: 'ส่งสำเร็จ', value: IReceiptStatus.OK },
  ];
};

export { getReceiptStatusColor, getReceiptStatus, getReceiptStatusOptions };
